// utils
import { ENV, MAIN_ENV } from '../../constants/global.constants';
// redux
import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';

const country = MAIN_ENV.COUNTRY;

export const strapiApi = createApi({
  reducerPath: 'strapiApi',
  baseQuery: retry(
    fetchBaseQuery({
      baseUrl: '', // Strapi usa una URL base diferente, se construye en el endpoint
    }),
    {
      maxRetries: 1,
    }
  ),
  endpoints: (builder) => ({
    getStrapiContent: builder.query({
      query: (section = '') => {
        const project = ENV[country].REACT_APP_HABI_CMS_STRAPI_PROJECT;
        const strapiBasePath = ENV[country].REACT_APP_STRAPI_BASE_PATH;
        const page = `${country.toLowerCase()}_${section}`;
        const getPageByQuery = `getPageByQuery?country=${country}&project=${project}&page=${page}`;
        const url = `${strapiBasePath}${getPageByQuery}`;

        return { url };
      },
      // Transformar la respuesta
      transformResponse: (response) => {
        return response;
      },
      // Manejar errores
      transformErrorResponse: (response) => {
        return {
          message: response?.data?.message || response?.statusText || 'Error al obtener contenido de Strapi',
        };
      },
    }),
  }),
});

export const { useGetStrapiContentQuery } = strapiApi;

